export const POST_RESOURCE_PLANNER_CHANGE_KEY = 'POST_RESOURCE_PLANNER_CHANGE';
export const POST_RESOURCE_PLANNER_CHANGE_MSW_STATUS_KEY = 'PostResourcePlannerChange';
